<template>
    <div class="panel-body">
        <div class="form-group">
            <textarea class="form-control"
                      :value="phoneticInput.text"
                      placeholder="Write Bangla here in English font (phonetically)"
                      @input="handleInputChange"  ></textarea>
        </div>
        <div style="text-align: center;">
            <button type="submit" class="btn btn-default" style="margin-right: 5px" @click="handleSubmit">
                <i class="fa fa-pencil fa-fw"></i>&nbsp; Convert English to Bangla
            </button>
            <button id="clrBtn" type="button" class="btn btn-danger" @click="clearInput">
                <i class="fa fa-trash-o fa-lg"></i>&nbsp; Clear Input Box
            </button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'PhoneticInput',
    computed: {
        ...mapGetters({
            phoneticInput: 'phoneticInput'
        })
    },
    methods: {
        emitInputChanged (value) {
            this.$emit('inputChanged', value);
        },
        handleInputChange (e) {
            this.emitInputChanged(e.target.value);
        },
        clearInput () {
            this.emitInputChanged('');
        },
        handleSubmit () {
            this.emitInputChanged(this.phoneticInput.text);
        }
    }
};
</script>
